import { render, staticRenderFns } from "./textDefault.vue?vue&type=template&id=8eb760a6"
import script from "./textDefault.vue?vue&type=script&lang=js"
export * from "./textDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports